export const ca = {
    "TRIGGER_LISTEN": "Escoltant activadors",
    "ASSIST_EMPTY_MSG": "Agent AI està escoltant activament la teva conversa i llest per assistir automàticament quan es desencadeni.",
    "MYBOT_TRIGGET_LISTEN": "No hi ha tasques actives de My Bot actualment",
    "MYBOT_EMTPY_MSG": "Per començar una tasca en My Bot, vés a la pestanya de cerca i selecciona l'opció \"Executa amb les entrades de l'agent\" per a la tasca desitjada.",
    "PROACTIVE_MODE": "Mode Proactiu",
    "SETTINGS": "Configuració",
    "HELP_AND_SUPPORT": "Ajuda i Suport",
    "HELP": "Ajuda",
    "LANGUAGE": "Idioma",
    "THEME": "Tema",
    "AUTOMATIC": "Automàtic",
    "DARK": "Fosc",
    "LIGHT": "Clar",
    "THEME_DESC": "Això utilitzarà el mode predeterminat del sistema",
    "DOCUMENTATION": "Documentació",
    "DOC_DESC": "Consulta els nostres articles de documentació detallada.",
    "FAQ_U": "FAQ",
    "FAQ_DESC": "Consulta les preguntes més freqüents sobre Agent AI.",
    "KORE_ACADEMY": "Acadèmia Kore",
    "KORE_ACA_DESC": "Aprèn més sobre Agent AI a través dels cursos d'acadèmia.",
    "SEARCH": "Cerca",
    "TAP_SEARCH":"Toqueu per cercar",
    "MY_BOT": "El Meu Bot",
    "ASSIST": "Assistir",
    "TRANSCRIPT": "Transcripció",
    "HISTORY": "Historial",
    "STARTOVER": "Comença de nou",
    "RESTART_INPUTS": "Reinicia amb entrades capturades",
    "ASKCUSTOMER": "Pregunta al Client",
    "TELLCUSTOMER": "Digue-li al Client",
    "WELCOME_MSG": "Missatge de Benvinguda",
    "SEND": "Envia",
    "SENT": "Enviat",
    "AWAITING": "Esperant resposta | Escriu per continuar",
    "OVERRIDE": "Escriu per continuar",
    "OVERRIDE_FILE": "Adjunta un fitxer per continuar",
    "ACCEPT_RESPONSE": "Resposta Acceptada",
    "AGENT_ENTERED": "L'agent ha entrat",
    "EXPECTED_FORMAT": "Format esperat",
    "INPUT_VALUES": "Valors d'entrada",
    "RESTART": "Reinicia",
    "START_OVER": "Comença de nou",
    "RESTART_CAPTURE": "Reinicia amb entrades capturades",
    "CANCEL": "Cancel·la",
    "INTERRUPT_DIALOG": "DIÀLEG INTERRUPT",
    "RUN": "Executa",
    "RUN_AGENT": "Executa amb l'entrada de l'agent",
    "STEP": "Pas",
    "DIALOG_TASK": "Tasques de Diàleg",
    "FAQ": "FAQ",
    "SNIPPET": "Respostes",
    "ARTICLE": "Pàgines web",
    "FILE": "Fitxers",
    "SUGGESTED": "Suggereix",
    "ALL_DIALOG": "Tots els Diàlegs",
    "DIALOG_TEXT": "Diàleg",
    "INTENT_IDENTIFIED": "Emissió del client",
    "NOT_WHAT_LOOKING": "Suggeriment incorrecte?",
    "BOT": "Bot",
    "CUSTOMER": "Client",
    "YOU": "Tu",
    "TERMINATE_CONV": "Finalitza tasca de diàleg",
    "TERMINATE_CONV_DESC": "Estàs segur que vols finalitzar la tasca de diàleg? L'Agent AI ja no podrà fer suggeriments.",
    "YES_TERMINATE": "Sí, Finalitza",
    "NO_CANCEL": "No, Cancel·la",
    "OVERRIDE_CONTINUE": "Continua amb el mode d'alteració",
    "SUMMARY_TEXT": "Resum",
    "SUBMIT": "Envia",
    "INTERRUPT_OCCURED": "Ha ocorregut una interrupció",
    "IDENTIFIED_INTENT": "Intenció identificada",
    "INTERRUPT_DESC": "Executar això finalitzarà la teva tasca de diàleg en curs.",
    "ACCEPT_RUN": "Accepta i Executa",
    "RUN_LATER": "Executa més tard",
    "KNOW_MORE": "Saber-ne més",
    "MORE_TEXT": "Més",
    "LESS_TEXT": "Menys",
    "VIEW_MORE": "Veure més",
    "VIEW_LESS": "Veure menys",
    "SHOW_MORE_FAQ": "Mostra més preguntes freqüents",
    "SHOW_LESS_FAQ": "Mostra menys preguntes freqüents",
    "SHOW_MORE_ARTICLE": "Mostra més pàgines web",
    "SHOW_LESS_ARTICLE": "Mostra menys pàgines web",
    "SHOW_MORE_SNIPPET": "Mostra més respostes",
    "SHOW_LESS_SNIPPET": "Mostra menys respostes",
    "SHOW_MORE_FILES": "Mostra més fitxers",
    "SHOW_LESS_FILES": "Mostra menys fitxers",
    "VIEW_ALL_DIALOG": "Mostra tots els diàlegs",
    "VIEW_FEW_DIALOG": "Mostra uns pocs diàlegs",
    "HELP_FULL": "És útil?",
    "THANKYOU": "Gràcies!",
    "EXPAND_MORE": "Amplia / Més",
    "CLOSE_TEXT": "Tanca",
    "STARTED": "Iniciat",
    "ENDED": "Finalitzat",
    "VIEW_FULL_ARTICLE": "Veure pàgina web",
    "VIEW_FULL_FILE": "Veure fitxer",
    "COPIED": "Copiat",
    "SENTI_ANALY": "Anàlisi de Sentiment",
    "WRONG_SUGGESTION": "Suggeriment incorrecte",
    "INCORRECT_INTENT": "Intenció incorrecta",
    "ACCIDENTAL_CLICK": "Clic accidental",
    "TIME_TAKING": "Llarg temps",
    "OTHER": "Altres",
    "PLAYBOOK_EMPTY_MSG": "Selecciona Playbook",
    "PLAYBOOK_EMPTY_DESC": "Agent AI no ha pogut carregar el playbook perquè tots els playbooks disponibles són dinàmics. Fes clic a 'Selecciona Playbook' per accedir al playbook.",
    "STAGE": "Etapa",
    "PROCEED_TO_CLOSE": "Continua per tancar",
    "RECOMENDED_PLAYBOOK": "PLAYBOOK RECOMANAT",
    "PRIMARY_SCRIPTS": "SCRIPTS PRINCIPALS",
    "DYNAMIC_SCRIPTS": "SCRIPTS DINÀMICS",
    "RESUME": "Repren",
    "ENABLE_CLOSE": "Fes clic a continuar per tancar el botó per habilitar l'etapa de tancament",
    "LIST_VIEW": "Vista en Llista",
    "TERMINATE": "Finalitza",
    "MINIMIZE": "Minimitza",
    "FILE_NAME":"Nom del fitxer",
    "MAXIMIZE": "Maximitza",
    "NO_SEARCH_RESULT": "No s'ha trobat cap resultat de cerca",
    "SENTIMENT_AWAITING": "Esperant sentiment",
    "POSITIVE": "Positiu",
    "NEGATIVE": "Negatiu",
    "TAB_TEXT":"No hi ha cap pestanya activada! Si us plau, activa almenys una pestanya",
    "AUTO_SCROLL_TOOLTIP":"Controla el desplaçament automàtic de la pestanya Assistència, el meu bot i el contingut de la pestanya Transcripció",
    "ASSOCIATED_WORK_NOTES": "Notes de resolució passades",
    "AGENT_JOINED_CONV": "Agent s'ha unit a la conversa",
    "AUTOSCROLL_ASSIST": "Auto-Scroll contingut de la pestanya d'assistència",
    "FILE_SIZE_MSG": "La mida del fitxer ha de ser dins de 25MB. Torna a intentar-ho.",
    "OVERRIDE_BTN": "Substituir",
    "CHOOSE_FILE": "Tria Fitxer",
    "SUMMARY_ERROR_TEXT": "Ho sentim, però hi ha hagut un problema en generar el resum d'aquesta conversa. Crea el teu propi resum, si us plau",
    "ASK_A_QUESTION": "Fes una pregunta",
    "COPY": "Copia",
    "PLAYBOOK": "Playbook",
    "TELL_US_MORE": "Explica'ns més…",
    "THANKS_FEEDBACK": "Gràcies pel teu comentari",
    "SOMETHING_WRONG": "Alguna cosa ha anat malament",
    "CLICK_ERROR_DETAILS": "Fes clic per veure els detalls de l'error",
    "NO_ACTIVE_PLAYBOOK": "No hi ha cap manual actiu",
    "REPHRASE_QUESTION": "Pots reformular la teva pregunta o preguntar una altra cosa?",
    "INTERNAL_INFO": "Informació interna",
    "SOURCES": "Fonts",
    "CONVERSATION_SUMMARY": "Resum de la conversa",
    "WAITING": "Esperant",
    "WIDGET_DISABLED": "El giny està desactivat",
    "AI_SETTINGS_DISABLED": "La configuració de l'Agent AI està desactivada! Contacta amb l'administrador de l'AI",
    "SERVER_CONNECTION_ERROR": "Error en connectar amb el servidor",
    "VIEW": "Veure",
    "ATTACHMENT_INPUT": "Entrada d'adjunt",
    "TYPE_SUMMARY": "Escriu un resum",
    "VIEW_FULL_ARTICLE_2": "Veure article complet",
    "VIEW_FULL_FILE_2": "Veure fitxer complet",
    "BY":"Per",
    GENERATE_SUMMARY: "Generar resum",
    PREV_SUMMARIES: "Resums generats anteriorment",
    DIALOG_WORKFLOWS: "Fluxos de treball de diàleg",
    SHOW_ALL_DIALOG: "Mostra totes les tasques de diàleg",
    SHOW_ALL_DIALOGS: "Mostra tots els diàlegs",
    CUSTOM_TAB: "Pestanya personalitzada",
    AGENT_INPUT: "Entrada de l'agent",
    "CUSTOM_EMPTY_MSG" : "No hi ha cap flux de treball actiu actualment",
    "CUSTOM_TAB_DESC" : "Per començar un flux de treball, executa un dels que hi ha a la llista que hi ha a la part inferior de la pantalla.",
    "SUBMIT_OVERALL_FEEDBACK" : "Enviar comentari global",
    "FEEDBACK_POPUP_SUBTITLE" : "Coments sobre el widget i les seves funcions",
    "FEEDBACK_SATISFIED" : "Satisfech",
    "FEEDBACK_UNSATISFIED" : "No satisfech",
    "FEEDBACK_PROVIDE_REASONS" : "Proporcionar més informació…",
    "FEEDBACK_TITLE" : "Comentari",
    "AGENTIC_THINKING" : "Pensant",
    "AGENTIC_AGENT_TITLE" : "Agent",
    "AGENTIC_COPILOT_MODE_TITLE" : "Mode Copilot Agentic",
    "AGENTIC_SENDING_MESSAGE" : "Enviant...",
    "AGENTIC_COPILOT_DESC" : "Agentic Copilot està escoltant activament la teva conversa i està llest per assistir automàticament",
    "AGENTIC_SEARCH_RESULTS" : "Resultats Agents"
}